/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { AsyncRequestState } from '@modules/ui-types'

import {
  resetRetryPastDueInvoicesRequest,
  retryPastDueInvoices,
} from '@/apps/adminconsole/actions/saasOrganizations'
import { retryPastDueInvoicesRequest } from '@/apps/adminconsole/reducers/registry'

import RetryInvoicesButton from './RetryInvoicesButton'

import type { ReduxState } from '@/types/redux'

interface StateProps {
  retryInvoicesRequest: AsyncRequestState
}

interface DispatchProps {
  retryInvoices: () => void
  resetRetryInvoices: () => void
}

interface ConsumerProps {
  organizationId: string
}

const mapStateToProps = (state: ReduxState, { organizationId }: ConsumerProps): StateProps => ({
  retryInvoicesRequest: retryPastDueInvoicesRequest(state, organizationId),
})

const mapDispatchToProps = (dispatch, { organizationId }: ConsumerProps): DispatchProps => ({
  retryInvoices: () => dispatch(retryPastDueInvoices(organizationId)),
  resetRetryInvoices: () => dispatch(resetRetryPastDueInvoicesRequest(organizationId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(RetryInvoicesButton)
